import { Component, HostBinding, OnDestroy, ChangeDetectorRef, OnInit, AfterViewInit, QueryList, ViewChildren, } from '@angular/core';
import { Observable } from 'rxjs';
import { CmsService } from '../../core/services/cms.service';
import { LogCategory, LoggerService, LogType, LogWidget } from '../../core/services/logger.service';
import { ProfileService } from '../../core/services/profile.service';
import { TagManagerService } from '../../core/services/tag-manager.service';
import { ProfileSetting } from '../../pages/profile/profile.component';
import { IWidgetComponent } from '../../shared/widget/i-widget-component';
import { Widget } from '../../shared/widget/widget';
import { NgbdSortableHeaderDirective, SortEvent } from '../../directives/table-column-sortable.directive';
import { LoadingWrapper } from '../../shared/loadingwrapper';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ComponentData } from '../../shared/component/component-meta';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-tile-page',
    templateUrl: './tile-page.component.html',
    styleUrls: ['./tile-page.component.scss'],
    standalone: false
})
export class TilePageComponent implements OnInit, OnDestroy, AfterViewInit, IWidgetComponent {
    public data: Widget;
    public widget: ComponentData;
    public isActive: boolean = false;
    public tags: string[] = [];
    public contentID: string = undefined;
    pages;
    filterText: '';

    @ViewChildren(NgbdSortableHeaderDirective) headers: QueryList<NgbdSortableHeaderDirective>;

    @HostBinding('class')
    get size(): string {
        return 'col-md-' + this.data.Size.toString();
    }

    constructor(
        private logger: LoggerService,
        public cms: CmsService,
        private gtm: TagManagerService,
        private changeDetector: ChangeDetectorRef,
        public activeModal: NgbActiveModal,
        public profileService: ProfileService,
        private modalService: NgbModal,
        private route: ActivatedRoute,
    ) {
        this.log("constructor", null, LogCategory.Constructor);

        this.route.queryParamMap.
            subscribe(params => {
                if (params.get('id'))
                    this.contentID = params.get('id');
            });
    }

    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.Widget, LogWidget.MyLinks, category);
    }

    ngOnInit() {
        this.widget = this.data;
        this.log("ngOnInit", null, LogCategory.Init);
        if (this.contentID != undefined)
        {
            this.pages = new LoadingWrapper(this.cms.getV2ContentByTypeAndID$("TilePages", this.contentID));
            //this.data.IsModal = false;
            //this.widget.IsModal = false;
            //this.widget
        }
        else
            this.pages = new LoadingWrapper(this.cms.getV2ContentByTypeAndID$("TilePages", this.widget.meta.PageID));
    }

    ngOnDestroy() {
        this.log("ngOnDestroy", "", LogCategory.Destroy);
    }

    ngAfterViewInit() {
        // See https://blog.angularindepth.com/everything-you-need-to-know-about-the-expressionchangedafterithasbeencheckederror-error-e3fd9ce7dbb4
        // Added after error handling template added to component.
        this.changeDetector.detectChanges();
    }

    
}

